<template>
    <div class="hot_list">
        <div class="title_style">—— 热销TOP榜 ——</div>
        <div id="good-list">
            <div v-for="(item,index) in goodFreshList" :key="index" class="goods-item" @click="gotoDetail(item)">
                <img src="@/assets/good-fresh/fresh-images/0.jpg" alt="" class="goods-img">
                <div class="content-box">
                    <div>{{ item.title }}</div>
                    <div class="flex justify-between">
                        <span>
                            <span class="price">
                                <span style="font-size: 12px;">￥</span>
                                <span>12.6</span>
                            </span>
                            <span class="crossedPrice">￥11.1</span>
                        </span>
                        <span class="salesVolume">销量2334</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'GoodFresh',
        data() {
            return {
                goodFreshList: [
                    {
                        index: 0,
                        title: '绿鲜知 都市轻食 沙拉菜组合',
                        price: '24.80',
                        quantity: '700g'
                    },
                    {
                        index: 1,
                        title: '进口 巨无霸牛油果 单果重160-220g',
                        price: '44.80',
                        quantity: '4个',
                    },
                    {
                        index: 2,
                        title: '禧美海产 厄瓜多尔白虾（特大号）',
                        price: '109.00',
                        quantity: '1kg/盒',
                    },
                    {
                        index: 3,
                        title: '鲜活 加拿大进口 鲜活珍宝蟹',
                        price: '399.00',
                        quantity: '600-800g',
                    },
                    {
                        index: 4,
                        title: '德青源A+鲜鸡蛋',
                        price: '129.00',
                        quantity: '64枚',
                    },
                    {
                        index: 5,
                        title: '春禾秋牧 板腱牛排 ',
                        price: '37.80',
                        quantity: '200g',
                    },
                    {
                        index: 6,
                        title: '瑞士原装进口 大孔原制奶酪块芝士片',
                        price: '89.00',
                        quantity: '200g',
                    },
                    {
                        index: 7,
                        title: '法国原装进口伊斯尼杯装淡奶油',
                        price: '290.00',
                        quantity: '1L',
                    },
                ],
            }
        },
        methods: {
            gotoDetail() {
                this.$router.push({ name: 'ProductDetails', params: { id: 1 } })
            },
            getImagePath: function (name) {
                return require('@/assets/good-fresh/fresh-images/' + name + '.jpg');
            },
        }
    };
</script>

<style scoped>
    .hot_list {
        background: #fff;
        margin: 16px 0 24px 0;
        padding: 24px;
    }

    .title_style {
        color: #333;
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 12px;
    }

    #good-list {
        width: 1280px;
        margin: auto;
        padding: 16px;
        display: flex;
        flex-wrap: wrap;
        background: #fff;
    }

    .goods-item {
        width: 194px;
        height: 291px;
        margin-right: 17px;
        margin-bottom: 40px;
        background: #fff;
    }

    .goods-img {
        width: 194px;
        height: 194px;
        border-radius: 8px 8px 0 0;
    }

    .content-box {
        height: 90px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .price {
        color: #FD3B00;
        font-size: 18px;
    }

    .crossedPrice {
        color: #999;
        font-size: 14px;
        text-decoration: line-through;
    }

    .salesVolume {
        color: #999;
        font-size: 14px;
    }
</style>


// WEBPACK FOOTER //
// src/view/shop/components/goodsList.vue